import { TabPage } from '@components/TabPage'
import { Listbox, ListboxButton, ListboxOption, ListboxOptions } from '@headlessui/react'
import { generatePath, NavLink, Outlet, useLocation, useNavigate } from 'react-router'
import { CardSidebar } from 'shared-ui/components'
import { useLocalization } from 'shared-ui/localization'

import { ChevronDownIcon } from '../../../components/Icons'
import { path } from '../../../routes/paths'
import { AdminOnlyGuard } from '../components/AdminOnlyGuard'

const navLinkClassName = ({ isActive }: { isActive: boolean }) =>
  isActive
    ? 'font-semibold border-l-4 pl-4 border-green text-gray-900 py-2 block -mr-1'
    : 'text-gray-500 py-2 block pl-6'

export const AdminLayout: React.FC = () => {
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useLocalization()

  const links = [
    {
      pathname: generatePath(path.adminSoftwareReleases),
      label: t(($) => $.titles.softwareUpdates)
    },
    {
      pathname: generatePath(path.adminUsers),
      label: t(($) => $.titles.users)
    },
    {
      pathname: generatePath(path.adminOperations),
      label: t(($) => $.titles.operations)
    },
    {
      pathname: generatePath(path.adminStats),
      label: t(($) => $.titles.stats)
    },
    {
      pathname: generatePath(path.adminSettings),
      label: t(($) => $.titles.settings)
    }
  ]

  return (
    <AdminOnlyGuard>
      <TabPage title={t(($) => $.titles.admin)}>
        <div className="mt-8 md:flex">
          <CardSidebar className="hidden md:block">
            <ul>
              {links.map((link) => (
                <li key={link.pathname}>
                  <NavLink to={link.pathname} end className={navLinkClassName}>
                    {link.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </CardSidebar>
          <Listbox
            value={location.pathname}
            onChange={(p: string) => p && navigate(p)}
            as="nav"
            className="relative md:hidden"
          >
            <ListboxButton className="flex w-full items-center justify-between border border-gray-400 bg-white px-4 py-0.5 text-lg">
              {links.find((link) => link.pathname === location.pathname)?.label ??
                t(($) => $.chooseAPage)}
              <ChevronDownIcon />
            </ListboxButton>
            <ListboxOptions
              modal={false}
              className="absolute w-full border border-t-0 border-gray-400 bg-white"
            >
              {links.map((link) => (
                <ListboxOption
                  value={link.pathname}
                  key={link.pathname}
                  className="px-4 py-2 hover:bg-green-300"
                >
                  {link.label}
                </ListboxOption>
              ))}
            </ListboxOptions>
          </Listbox>

          <div className="w-full px-8 py-8 md:py-0">
            <Outlet />
          </div>
        </div>
      </TabPage>
    </AdminOnlyGuard>
  )
}
